import { createContext, useContext } from 'react';

/**
 * Two contexts for workout data:
 *  - WorkoutDataContext: state (workoutData, lastWeights, appliedProgression).
 *    Re-renders subscribers on every keystroke-frequency change.
 *  - WorkoutDataActionsContext: stable action callbacks (setters + helpers).
 *    Memoized so subscribers (e.g. "add exercise" buttons) never re-render
 *    on data change.
 *
 * This split is the foundation that Task 6's React.memo isolation
 * relies on. Components that only dispatch actions should subscribe to
 * `useWorkoutDataActions()` ONLY — they will not re-render on keystrokes.
 */
export const WorkoutDataContext = createContext(null);
export const WorkoutDataActionsContext = createContext(null);

export function useWorkoutData() {
  const ctx = useContext(WorkoutDataContext);
  if (!ctx) throw new Error('useWorkoutData must be used within WorkoutSessionProvider');
  return ctx;
}

export function useWorkoutDataActions() {
  const ctx = useContext(WorkoutDataActionsContext);
  if (!ctx) throw new Error('useWorkoutDataActions must be used within WorkoutSessionProvider');
  return ctx;
}
